import React from 'react'
import PropTypes from 'prop-types'
import { Route } from 'react-router-dom'
import Header from 'components/Header'
import Footer from 'components/Footer'
import portfolioChartIconSvg from 'assets/icons/icon-portfolio.svg'
import barChartIconSvg from 'assets/icons/icon-bar-chart.svg'
import { AccountBalanceWallet,  MonetizationOn } from '@material-ui/icons'
import logoForWhiteBackground from 'assets/images/logos/Zorkitron_logo_for_white_background.png'
import { FormattedMessage } from 'react-intl'
import { styles } from './styles.scss'

/* eslint-disable react/jsx-no-bind */
const AppLayoutRoute = ({ component: Component, path, routeKey }) => {
  const navLinks = [
    {
      label: <FormattedMessage id="global.header.navigation.link1" />,
      link: '/deposit',
      icon: AccountBalanceWallet
    },
    {
      label: <FormattedMessage id="global.header.navigation.link2" />,
      link: '/withdraw',
      icon: MonetizationOn
    }
  ]

  return (
    <Route
      path={path}
      key={routeKey}
      render={matchProps => (
        <div className={styles}>
          <div className="app-shell">
            <Header
              layout="app"
              logo={logoForWhiteBackground}
              navLinks={navLinks}
            />
            <Component {...matchProps} />
          </div>
          <Footer />
        </div>
      )}
    />
  )
}

AppLayoutRoute.propTypes = {
  component: PropTypes.func.isRequired,
  path: PropTypes.string.isRequired,
  routeKey: PropTypes.string
}

AppLayoutRoute.defaultProps = {
  routeKey: ''
}

export default AppLayoutRoute
